import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './index.css';
import './styles/header.css'
import './styles/home.css'
import './styles/kontakt.css'
import './styles/footer.css'
import './styles/adminGaleria.css'
import './styles/modalViewer.css'
import './styles/adminDashboard.css'
import './styles/galeria.css'
import './styles/wspolpraca.css'
import './styles/produkcja.css'
import './styles/slider.css'
import './styles/contactBar.css'

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path='/*' element={<App/>}/>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
